import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/redux';
import WelcomeModal from '../../../components/modal/WelcomeModal';
import DashboardTable from './DashboardTable';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    const checkFirstTimeLogin = () => {
      if (!user) return;
      const hasSeenWelcome = localStorage.getItem(`welcome_shown_${user.id}`);
      
      if (!hasSeenWelcome) {
        setShowWelcomeModal(true);
      }
    };

    checkFirstTimeLogin();
  }, [user]);

  const handleWelcomeClose = () => {
    if (user) {
      localStorage.setItem(`welcome_shown_${user.id}`, 'true');
    }
    setShowWelcomeModal(false);
  };
  const handleGoToSettings = () => {
    if (user) {
      localStorage.setItem(`welcome_shown_${user.id}`, 'true');
    }
    setShowWelcomeModal(false);
    navigate('/settings?tab=dsps');
  };

  return (
    <>
      <div className="rounded-lg shadow-lg dashboard-container bg-gray-50">
        <DashboardTable />
      </div>

      {/* Welcome Modal */}
      <WelcomeModal
        isOpen={showWelcomeModal}
        onClose={handleWelcomeClose}
        onGoToSettings={handleGoToSettings}
      />
    </>
  );
};

export default Dashboard;